export default __webpack_public_path__ + "static/media/headshot.921052fb.png";